import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Markdown Home',
      component: Home,
    },
    {
      path: '/:plink',
      name: 'Permalink',
      component: Home,
      props: true
    },
    {
      path: '*',
      name: 'Redirect',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js